import React, {useEffect, useState} from "react";

export type IntervalFormat = "hour" | "minute";

type Props = {
    label: string;
    initialValue: number; // stored in seconds
    initialFormat: IntervalFormat;
    onChange: (seconds: number, format: IntervalFormat) => void;
};

const MULTIPLIERS: Record<IntervalFormat, number> = {
    hour: 3600,
    minute: 60,
};

const FORMATS: {value: IntervalFormat; label: string}[] = [
    {value: "minute", label: "Min"},
    {value: "hour", label: "Hr"},
];

export function IntervalInputV2({label, initialValue, initialFormat, onChange}: Props) {
    const [format, setFormat] = useState<IntervalFormat>(initialFormat);
    const [displayValue, setDisplayValue] = useState<number>(
        initialValue / MULTIPLIERS[initialFormat]
    );

    useEffect(() => {
        onChange(displayValue * MULTIPLIERS[format], format);
    }, [displayValue, format]);

    const handleFormatChange = (newFormat: IntervalFormat) => {
        // convert current display value to seconds, then to new format
        const seconds = displayValue * MULTIPLIERS[format];
        setDisplayValue(Math.max(1, Math.round(seconds / MULTIPLIERS[newFormat])));
        setFormat(newFormat);
    };

    return (
        <div className="flex flex-col gap-1">
            <label className="font-medium text-sm">{label}</label>
            <div className="flex h-9 rounded-md shadow-md overflow-hidden">
                <input
                    type="number"
                    min={1}
                    className="flex-1 min-w-0 px-3 bg-white text-sm outline-none border-r border-light-light-grey"
                    value={displayValue}
                    onChange={e => setDisplayValue(parseFloat(e.target.value) || 0)}
                />
                <div className="flex">
                    {FORMATS.map(f => (
                        <button
                            key={f.value}
                            type="button"
                            onClick={() => handleFormatChange(f.value)}
                            className={`px-3 text-sm font-medium transition-colors ${
                                format === f.value
                                    ? "bg-blue text-white"
                                    : "bg-white text-dark-dark-grey hover:bg-light-light-grey"
                            }`}
                        >
                            {f.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
